<template>
  <div class="flex flex-col bg-block shadow-primaryBlock rounded
                  p-8 lg:px-12 lg:pt-13 lg:pb-10">
    <div class="text-xl font-bold text-text leading-tight mb-11">{{ $t('navTitle') }}</div>
    <div v-for="(route,i) in routes" :key="i" class="flex items-center mb-8">
      <router-link :to="route.to" class="link" exact-active-class="link-active">
        <component :is="`icon-${route.icon}`" class="mr-4"/>
        {{ route.name }}
      </router-link>
      <div v-show="Object.keys(route).includes('locked')" class="ml-auto">
        <IconLock v-if="route.locked" class="text-icon w-5"/>
        <IconLockOpen v-else class="text-icon w-5 h-5"/>
      </div>
    </div>
    <ConfirmEmail v-if="user_info.data.status === 0" class="mt-auto"/>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import ConfirmEmail from "@/components/cabinet/ProfileSettings/ConfirmEmail";
import IconLock from "@/components/icons/IconLock";
import IconDashboard from "@/components/icons/IconDashboard";
import IconAgent from "@/components/icons/operationIcons/IconAgent";
import IconCogFilled from "@/components/icons/IconCogFilled";
import IconMonitor from "@/components/icons/IconMonitor";
import IconLockOpen from "@/components/icons/IconLockOpen";
import IconSpeechBubble from "@/components/icons/IconSpeechBubble";
import IconCog from "@/components/icons/IconCog";

export default {
  name: "ProfileSettingsNav",
  components: {
    IconCog,
    IconSpeechBubble,
    IconLockOpen, IconMonitor, IconCogFilled, IconAgent, IconDashboard, IconLock, ConfirmEmail
  },
  computed: {
    ...mapState('cabinet/user', ['user_info']),
    ...mapGetters('space', ['spacesList']),
    routes() {
      const userHasTeamSpace = this.spacesList.some(space => space.type === 3);
      const routes = [
        {
          to: {name: 'profile-settings'},
          name: this.$t('mainSettings'),
          icon: 'cog-filled',
          locked: this.$store.state.cabinet.passwordGuard.active
        },
        {to: {name: 'personalization'}, name: this.$t('personalization'), icon: 'agent'},
        {to: {name: 'notifications'}, name: this.$t('notifications'), icon: 'speech-bubble'},
        {to: {name: 'theming'}, name: this.$t('theming'), icon: 'dashboard'},
        {
          to: {name: 'sessions'},
          name: this.$t('activeDevices'),
          icon: 'monitor',
          locked: this.$store.state.cabinet.passwordGuard.active
        },
        {
          to: {name: 'user-api'},
          name: 'API',
          icon: 'cog',
          hidden: !userHasTeamSpace
        },
      ]
      return routes.filter(item => !item?.hidden)
    }
  },
  i18n: {
    messages: {
      en: {
        navTitle: 'User profile',
        mainSettings: 'Profile settings',
        personalization: 'Personalization',
        notifications: 'Notifications',
        theming: 'Theming',
        activeDevices: 'Active devices'
      },
      ru: {
        navTitle: 'Профиль пользователя',
        mainSettings: 'Настройки профиля',
        personalization: 'Персонализация',
        notifications: 'Уведомления',
        theming: 'Оформление',
        activeDevices: 'Активные устройства'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.link {
  @apply flex text-text-secondary text-sm;
  transition: all .2s;

  svg {
    @apply text-icon ;
    width: 1.6rem;
    height: 1.6rem;
    transition: all .2s;
  }

  &:hover, &.link-active {
    @apply text-red;

    svg {
      @apply text-red;
    }
  }
}
</style>